export default {"src":"/_next/static/image/public/images/ic_new_increase_product.0fa57a03874d77890d6f2a1a1de1b60f.svg","height":36,"width":35};